import { z } from 'zod'
import { CONSENT_COOKIE_VERSION } from '../constants'

export type AnalyticsConsentState = 'granted' | 'denied' | 'unset'

export interface CookieConsentValue {
  analytics: boolean
  timestamp: string
  version: number
}

const consentSchema = z.object({
  analytics: z.boolean(),
  timestamp: z.string(),
  version: z.number(),
})

export function consentStateFromValue(value: unknown): AnalyticsConsentState {
  const parsed = consentSchema.safeParse(value)
  if (!parsed.success || parsed.data.version < CONSENT_COOKIE_VERSION) {
    return 'unset'
  }
  return parsed.data.analytics ? 'granted' : 'denied'
}

export function consentStateFromRawCookie(raw: unknown): AnalyticsConsentState {
  // both server consumers (h3 getCookie, cookie-parser) hand over already-URI-decoded
  // values; the startsWith guard skips a guaranteed thrown exception for non-JSON input
  if (typeof raw !== 'string' || !raw.startsWith('{')) {
    return 'unset'
  }
  try {
    return consentStateFromValue(JSON.parse(raw))
  } catch {
    return 'unset'
  }
}

export function resolveApexCookieDomain(hostname: string): string | undefined {
  // IP hosts (e.g. 127.0.0.1 in CI e2e) get a host-only cookie — a derived ".0.1"
  // domain attribute would make the browser reject the cookie outright
  if (hostname.includes(':') || /^[\d.]+$/.test(hostname)) {
    return undefined
  }
  const labels = hostname.split('.')
  return labels.length > 1 ? `.${labels.slice(-2).join('.')}` : undefined
}
